import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { requestCheckOrgaId } from "../redux/actions/userActionCreators";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";

const OrgaController = ({ open, handleClose }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const formik = useFormik({
        initialValues: {
            email: "",
            orgaName: "",
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .email(t("valid_email"))
                .max(255)
                .required(t("required_field")),
            orgaName: Yup.string()
                .required(t("required_field"))
                .matches(
                    /^([a-zA-Z0-9-]){0,1000}$/,
                    t("only_alphanumeric")
                ),
        }),
        onSubmit: (values) => {
            dispatch(requestCheckOrgaId(values.email, values.orgaName, handleClose));
        },
    });

    return (
        <div>
            <Dialog
                disableEnforceFocus
                open={open}
                onClose={handleClose}
                aria-labelledby="draggable-dialog-title"
                disableBackdropClick
            >
                <form onSubmit={formik.handleSubmit}>

                    <DialogContent>
                        <DialogContentText>
                            <Grid container>
                                <Grid item xs={12} mb={4}>
                                    <Typography variant="body1">
                                        {t("email_and_orga_name")}{" "}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} mb={2}>
                                    <Typography variant="body2">{t("email_address")}*</Typography>
                                    <TextField
                                        id="outlined-basic"
                                        placeholder={t("email_address")}
                                        name="email"
                                        variant="outlined"
                                        fullWidth
                                        inputProps={{
                                            style: {
                                                height: "16px",
                                            },
                                        }}
                                        error={Boolean(formik.touched.email && formik.errors.email)}
                                        helperText={formik.touched.email && formik.errors.email}
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                        value={formik.values.email}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        {t("display_name_A")}*
                                    </Typography>
                                    <TextField
                                        id="outlined-basic"
                                        placeholder={t("display_name_A")}
                                        name="orgaName"
                                        variant="outlined"
                                        fullWidth
                                        inputProps={{
                                            style: {
                                                height: "16px",
                                            },
                                        }}
                                        error={Boolean(
                                            formik.touched.orgaName && formik.errors.orgaName
                                        )}
                                        helperText={
                                            formik.touched.orgaName && formik.errors.orgaName
                                        }
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                        value={formik.values.orgaName}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" onClick={handleClose}>
                            {t("cancel")}
                        </Button>
                        <Button variant="contained" color="secondary" type="submit">
                            {t("confirm")}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>

        </div >
    );
};

export default OrgaController;
